import SEOHead from "@/components/General/SEOHead";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Home from "@/modules/Home/Home";

const HomePage = () => {
  return (
    <>
      <SEOHead />
      <Home />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});
export default HomePage;
